import { fuzzySearch } from "utils/fuzzySearch";
import { uniqById } from "utils/uniq";
import { SortStateDescriptor } from "components/Filters/types";

import {
  SharedModuleType,
  SharedModuleDataWithSpace,
  SharedModuleDataWithAccount,
  ModuleSortableFields,
} from "./types";
import { GetSharedModulesData } from "./gql";
export const processSharedModules = (
  data: GetSharedModulesData | undefined
): (SharedModuleDataWithSpace | SharedModuleDataWithAccount)[] => {
  return (
    data?.sharedModulesV2.reduce(
      (acc, share) => {
        if (share.to.space?.id) {
          const sameModule = acc.filter((item) => item.id === share.module.id);

          if (sameModule.length && "space" in sameModule[0]) {
            sameModule[0].spaces = [...(sameModule[0].spaces || []), share.to.space];
          } else {
            acc.push({
              ...share.module,
              space: share.from.space,
              type: SharedModuleType.SPACE,
              spaces: [share.to.space],
            });
          }
        } else {
          acc.push({
            ...share.module,
            subdomain: share.from.account.subdomain,
            type: SharedModuleType.ACCOUNT,
          });
        }
        return acc;
      },
      [] as SharedModuleDataWithSpace[] | SharedModuleDataWithAccount[]
    ) || []
  );
};

export const filterAndSortModules = (
  modules: (SharedModuleDataWithSpace | SharedModuleDataWithAccount)[],
  searchQuery: string | null,
  sortState: Partial<SortStateDescriptor>
): (SharedModuleDataWithSpace | SharedModuleDataWithAccount)[] => {
  const filteredModules = uniqById(modules);

  if (sortState) {
    const { sortKey, sortDirection } = sortState;
    filteredModules.sort((a, b) => {
      const aValue = a[sortKey as ModuleSortableFields];
      const bValue = b[sortKey as ModuleSortableFields];
      if (aValue === undefined || bValue === undefined) return 0;
      if (aValue < bValue) return sortDirection === "ASC" ? -1 : 1;
      if (aValue > bValue) return sortDirection === "ASC" ? 1 : -1;
      return 0;
    });
  }

  if (searchQuery) {
    return fuzzySearch(filteredModules, searchQuery.trim(), {
      keys: ["id", "name", "description"],
      scoreThreshold: -1000,
    });
  }

  return filteredModules;
};
